import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { ErrorBoundary } from './ui/ErrorBoundary';
// First, so the app's own copy of Lexend is declared before anything asks for
// it. It used to come off the network, which is what left us on a grey screen.
import './ui/fonts.css';
import './styles.css';
import './ui/shell/shell.css';

const root = document.getElementById('root');
if (!root) throw new Error('Missing #root element');

createRoot(root).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);

/**
 * Take the boot marker down (see index.html).
 *
 * It is marked gone BEFORE it is removed, so the twenty-second "did not finish
 * starting" timer knows we made it even if the element is already off the page.
 * Removed on the next frame rather than this one, so React has actually painted
 * something behind it and there is no flash of nothing in between.
 */
const boot = document.getElementById('boot');
if (boot) {
  boot.dataset.gone = '1';
  requestAnimationFrame(() => requestAnimationFrame(() => boot.remove()));
}
